/* ============================================================
   pj-events.js — event RSVP (plan/careers-and-events.md §B4).
   On an event page, [data-pj-rsvp] holds the form; submitting POSTs
   {app-proxy}/events/rsvp with { eventHandle, partySize, name?, email?, website? }.
   The backend (api/events-rsvp.js) reads the event itself, enforces the
   members-first window and capacity, and answers with a status. Guests see
   name + email fields; signed-in members RSVP in one tap.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-pj-rsvp]');
  if (!root) return;
  var form = root.querySelector('[data-pj-rsvp-form]');
  var out = root.querySelector('[data-pj-rsvp-result]');
  if (!form || !out) return;

  var proxy = (root.getAttribute('data-app-proxy') || '/apps/stylist').replace(/\/$/, '');
  var handle = root.getAttribute('data-event-handle');
  var loggedIn = root.getAttribute('data-logged-in') === 'true';
  var loginHref = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + '#rsvp');

  function say(html, isError) {
    out.innerHTML = html;
    out.classList.toggle('is-error', !!isError);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var payload = { eventHandle: handle, partySize: parseInt((form.elements.partySize || {}).value || '1', 10) };

    if (!loggedIn) {
      var name = (form.elements.name && form.elements.name.value || '').trim();
      var email = (form.elements.email && form.elements.email.value || '').trim();
      var website = (form.elements.website && form.elements.website.value || '');
      if (name.length < 2) { say('Please add your name so we know who to expect.', true); form.elements.name.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) { say('That email doesn’t look right — could you check it?', true); form.elements.email.focus(); return; }
      payload.name = name; payload.email = email; payload.website = website;
    }

    var original = btn.textContent;
    btn.setAttribute('aria-disabled', 'true'); btn.disabled = true; btn.textContent = 'Saving…';
    say('');

    fetch(proxy + '/events/rsvp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d || {} }; }); })
      .then(function (res) {
        var d = res.data;
        if (res.status === 200 && d.ok) {
          var n = d.partySize || payload.partySize;
          var who = n > 1 ? 'a party of ' + n : 'you';
          if (d.status === 'waitlist') {
            say('<strong>You’re on the waitlist.</strong> This one is full for now — we’ll reach out if a spot opens for ' + who + '.');
          } else if (d.already) {
            say('<strong>You’re already on the list' + (d.status === 'waitlist' ? ' — waitlisted' : '') + '.</strong> See you there.');
          } else {
            say('<strong>You’re in.</strong> We’ve saved a spot for ' + who + '. Add it to your calendar above so it’s on the fridge.');
          }
          form.hidden = true;
          return;
        }
        if (res.status === 401 && d.error === 'members_only') {
          say('RSVP is open to Circle members first. <a href="' + esc(loginHref) + '">Sign in</a> or <a href="/account/register">join The Circle</a> to save your spot now.', true);
        } else if (res.status === 401) {
          window.location.href = loginHref;
        } else if (res.status === 409) {
          say('RSVPs aren’t being taken for this event.', true);
        } else if (res.status === 410) {
          say('This event has already happened — see <a href="/pages/events">what’s coming up</a>.', true);
        } else if (res.status === 429) {
          say('That’s a lot of RSVPs from here in a short time. Please try again in a little while.', true);
        } else if (res.status === 400 && d.error === 'coppa') {
          say('Please RSVP with an adult’s name — party size covers the little ones.', true);
        } else if (res.status === 400) {
          say('Please check the details and try again.', true);
        } else {
          say('We couldn’t save that just now. Please try again in a moment, or call the store.', true);
        }
        btn.removeAttribute('aria-disabled'); btn.disabled = false; btn.textContent = original;
      })
      .catch(function () {
        say('We couldn’t reach the store just now. Please try again in a moment.', true);
        btn.removeAttribute('aria-disabled'); btn.disabled = false; btn.textContent = original;
      });
  });
})();
